import {
  FileTextOutlined,
  ContainerOutlined,
  UserOutlined,
  EditOutlined
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

const dashBoardNavTree = [
  {
  key: 'dashboard',
  path: `${APP_PREFIX_PATH}/dashboard`,
  title: 'Dashboard',
  icon: UserOutlined ,
  breadcrumb: false,
  submenu: []
},
  {
  key: 'joblist',
  path: `${APP_PREFIX_PATH}/home/list-jobs`,
  title: 'joblist',
  icon: ContainerOutlined ,
  breadcrumb: false,
  submenu: []
},
{
  key: 'appliedjobs',
  path: `${APP_PREFIX_PATH}/home/applied-jobs`,
  title: 'appliedjobs',
  icon: FileTextOutlined ,
  breadcrumb: false,
  submenu: []
},
{
  key: 'editprofile',
  path: `${APP_PREFIX_PATH}/profile/edit`,
  title: 'Edit Profile',
  icon: EditOutlined ,
  breadcrumb: false,
  submenu: []
},
]

const navigationConfig = [
  ...dashBoardNavTree
]

export default navigationConfig;
